import Cookies from 'js-cookie';
import { cookieUtils } from '../utils/cookies.js';
/**
 * API service for SeerahVerse application
 * Handles all HTTP requests to the backend API
 */

// Base API configuration
//const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7257'
;const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://seerahverseacademia.com';


class ApiError extends Error {
    constructor(message, statusCode, errors = [], errorCode = null, flag = null) {
        super(message);
        this.name = 'ApiError';
        this.statusCode = statusCode;
        this.errors = errors;
        this.errorCode = errorCode;
        this.flag = flag;
    }
}
/**
 * ==================================================
 * API REQUEST INTERCEPTOR WITH TOKEN REFRESH
 * ==================================================
 * Ye function sabhi API calls handle karta hai
 * Automatic token refresh implement karta hai
 * Error handling aur retry logic provide karta hai
 */
const apiRequest = async (endpoint, options = {}) => {
    const url = `${API_BASE_URL}${endpoint}`;
    const isFormData = options.body instanceof FormData;
    // Get the access token from the cookie
    // const accessToken = Cookies.get('accessToken');
    // Cookies se access token fetch karta hai
    let accessToken = cookieUtils.getAccessToken();

    // Get timeout from options or use default (60000ms = 60 seconds for long operations like email)
    const timeout = options.timeout || 60000;

    // Create AbortController for timeout handling
    const controller = new AbortController();
    let timeoutId;

    // Set timeout only if timeout > 0
    if (timeout > 0) {
        timeoutId = setTimeout(() => {
            controller.abort();
        }, timeout);
    }

    // HTTP request configuration set karta hai
    const config = {
        method: options.method || 'GET',
        headers: {
            ...(isFormData ? {} : { 'Content-Type': 'application/json' }),// FormData hai to Content-Type nahi set karta
            ...(accessToken ? { 'Authorization': `Bearer ${accessToken}` } : {}),  // Authorization header add karta hai
            ...options.headers,
        },
        body: options.body,
        credentials: 'include'  // Cookies include karta hai CORS requests mein
    };

    // Add abort signal for timeout only if timeout is set
    if (timeout > 0) {
        config.signal = controller.signal;
    }

    // Remove Content-Type for FormData (browser will set it automatically)
    // FormData hai to Content-Type header remove karta hai (browser automatically set karega)
    if (isFormData && config.headers['Content-Type']) {
        delete config.headers['Content-Type'];
    }
    try {
        // MAKE API REQUEST
        const response = await fetch(url, config);

        // Clear timeout if request completes successfully
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        // If 401 and we have a refresh token, try to refresh
        // Agar response 401 hai aur access token hai to token refresh attempt karta hai
        if (response.status === 401 && accessToken) {
            const refreshToken = cookieUtils.getRefreshToken();
            if (refreshToken) {
                try {
                    // Refresh token endpoint call karta hai naye tokens ke liye
                    const refreshResponse = await authAPI.refreshToken(accessToken, refreshToken);

                    if (refreshResponse.success) {
                        // Update tokens in cookies
                        // Naye tokens cookies mein store karta hai
                        const { token, refreshToken: newRefreshToken, expiresAt, refreshTokenExpiresAt } = refreshResponse.data;

                        const msPerDay = 1000 * 60 * 60 * 24;
                        const accessDays = Math.max((new Date(expiresAt).getTime() - Date.now()) / msPerDay, 0.01);
                        const refreshDays = Math.max((new Date(refreshTokenExpiresAt).getTime() - Date.now()) / msPerDay, 0.01);
                        cookieUtils.setCookie('accessToken', token, accessDays);
                        cookieUtils.setCookie('refreshToken', newRefreshToken, refreshDays);

                        // Retry original request with new token
                        // Original request ko naye token ke saath retry karta hai
                        config.headers['Authorization'] = `Bearer ${token}`;
                        response = await fetch(url, config);
                    } else {
                        // Refresh failed, clear tokens and trigger auth state change
                        // Refresh fail hone par tokens clear karta hai aur login page redirect karta hai
                        cookieUtils.clearAuthCookies();
                        localStorage.removeItem('user');
                        window.dispatchEvent(new Event('auth:stateChanged'));
                        window.location.href = '/login';
                        throw new ApiError('Session expired, please login again', 401);
                    }
                } catch (refreshError) {
                    // Refresh process mein error aane par bhi login redirect karta hai
                    cookieUtils.clearAuthCookies();
                    localStorage.removeItem('user');
                    window.dispatchEvent(new Event('auth:stateChanged'));
                    window.location.href = '/login';
                    throw new ApiError('Session expired, please login again', 401);
                }
            } else {
                // No refresh token, redirect to login
                // Refresh token nahi hai to directly login redirect karta hai
                cookieUtils.clearAuthCookies();
                localStorage.removeItem('user');
                window.dispatchEvent(new Event('auth:stateChanged'));
                window.location.href = '/login';
                throw new ApiError('Please login again', 401);
            }
        }
        // Agar response successful nahi hai to error throw karta hai
        if (!response.ok) {
            let errorData;
            try {
                // Error response ko JSON mein parse karta hai
                errorData = await response.json();
            } catch (parseError) {
                errorData = { message: `HTTP ${response.status}` };
            }
            // Custom ApiError throw karta hai with details
            throw new ApiError(
                errorData.message || `HTTP ${response.status}`,
                response.status,
                errorData.errors,
                errorData.errorCode || null,
                errorData.flag || null
            );
        }

        // HANDLE SUCCESSFUL RESPONSE
        // ==================================================
        // Content-Type check karta hai response ka
        const contentType = response.headers.get('content-type');

        if (contentType?.includes('application/json')) {
            // JSON response ko parse karta hai
            const data = await response.json();
            return data;
        }
        // Non-JSON response directly return karta hai
        return response;
    } catch (error) {
        // Clear timeout if error occurs
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        // ERROR HANDLING AND TRANSFORMATION
        // ==================================================
        // Agar error already ApiError hai to directly throw karta hai
        if (error instanceof ApiError) throw error;

        // Handle timeout/abort errors
        if (error.name === 'AbortError' || error.name === 'TimeoutError') {
            throw new ApiError('Request timeout - the operation is taking longer than expected. It may still be processing in the background.', 0, [], 'TIMEOUT');
        }

        // Network errors handle karta hai
        if (error.name === 'TypeError' && error.message.includes('fetch')) {
            throw new ApiError('Network error - please check your internet connection and ensure the backend server is running', 0);
        }
        // Other errors ko ApiError mein convert karta hai
        throw new ApiError(error.message || 'An unexpected error occurred', 0);
    }
};
// Enhanced authAPI with better error handling
// AUTHENTICATION API METHODS
// ==================================================
// Authentication related API calls handle karta hai
const authAPI = {
    /**
    * ==================================================
    * USER REGISTRATION
    * ==================================================
    * Naye user ko register karta hai
    * FormData aur JSON dono formats support karta hai
    */
    register: async (userData) => {
        const isFormData = userData instanceof FormData;

        return apiRequest('/api/Authentication/register', {
            method: 'POST',
            body: isFormData ? userData : JSON.stringify(userData),
        });
    },
    /**
    * ==================================================
    * USER LOGIN
    * ==================================================
    * User credentials se login karta hai
    * Successful login par tokens cookies mein store karta hai
    */
    login: async (credentials) => {
        const response = await apiRequest('/api/Authentication/login', {
            method: 'POST',
            body: JSON.stringify(credentials),
        });

        if (response.success) {
            // Set cookies
            // Response se tokens extract karta hai
            const { token, refreshToken, expiresAt, refreshTokenExpiresAt } = response.data;
            const msPerDay = 1000 * 60 * 60 * 24;
            const accessDays = Math.max((new Date(expiresAt).getTime() - Date.now()) / msPerDay, 0.01);
            const refreshDays = Math.max((new Date(refreshTokenExpiresAt).getTime() - Date.now()) / msPerDay, 0.01);
            cookieUtils.setCookie('accessToken', token, accessDays);
            cookieUtils.setCookie('refreshToken', refreshToken, refreshDays);
        }
        return response;
    },
    /**
     * ==================================================
     * TOKEN REFRESH
     * ==================================================
     * Expired access token ko refresh karta hai
     * Naye tokens generate karta hai
     */
    refreshToken: async (accessToken, refreshToken) => {
        // We are not using this in the interceptor because we created a separate function
        // But we can keep it for manual use if needed
        return apiRequest('/api/Authentication/refresh-token', {
            method: 'POST',
            body: JSON.stringify({ accessToken, refreshToken }),
        });
    },
    /**
     * ==================================================
     * USER LOGOUT
     * ==================================================
     * User logout karta hai aur server-side token revoke karta hai
     * Client-side tokens clear karta hai
     */
    logout: async () => {
        const refreshToken = Cookies.get('refreshToken');
        if (refreshToken) {
            // Server-side token revoke karta hai
            await apiRequest('/api/Authentication/revoke-token', {
                method: 'POST',
                body: JSON.stringify({ refreshToken }),
            });
        }
        // Client-side tokens clear karta hai
        cookieUtils.clearAuthCookies();
    },

    /**
     * ==================================================
     * FORGET PASSWORD
     * ==================================================
     * User ka email address lekar password reset token send karta hai
     */
    forgetPassword: async (email) => {
        return apiRequest('/api/Authentication/forget-password', {
            method: 'POST',
            body: JSON.stringify({ email }),
        });
    },

    /**
     * ==================================================
     * RESET PASSWORD
     * ==================================================
     * Token aur new password se user password reset karta hai
     */
    resetPassword: async (resetCode, newPassword, confirmPassword) => {
        return apiRequest('/api/Authentication/reset-password', {
            method: 'POST',
            body: JSON.stringify({
                resetCode: resetCode,
                newPassword: newPassword,
                confirmPassword: confirmPassword
            }),
        });
    },
    /**
    * ==================================================
    * VALIDATE RESET TOKEN
    * ==================================================
    * Reset token ki validity check karta hai
    * Token expire hone se pehle hi user ko inform karne ke liye
    */
    validateResetToken: async (resetToken) => {
        return apiRequest('/api/Authentication/validate-reset-token', {
            method: 'POST',
            body: JSON.stringify({ resetToken }),
        });
    },

    /**
     * ==================================================
     * VERIFY EMAIL
     * ==================================================
     * Email verification token se user email verify karta hai
     */
    verifyEmail: async (token) => {
        return apiRequest(`/api/Authentication/verify-email?token=${token}`, {
            method: 'GET',
        });
    },

    /**
     * ==================================================
     * RESEND VERIFICATION EMAIL
     * ==================================================
     * User request par verification email dobara bhejta hai
     */
    resendVerificationEmail: async (email) => {
        return apiRequest('/api/Authentication/resend-verification-email', {
            method: 'POST',
            body: JSON.stringify({ email }),
        });
    },

    /**
     * ==================================================
     * CHECK EMAIL VERIFICATION STATUS
     * ==================================================
     * User ke email verification status check karta hai
     */
    checkEmailVerificationStatus: async (email) => {
        return apiRequest('/api/Authentication/check-Email-verification-status', {
            method: 'POST',
            body: JSON.stringify({ email }),
        });
    }
};

// COURSE API METHODS
const courseAPI = {
    /**
     * Get courses with pagination and filtering for admin
     */
    getCoursesWithPagination: async (query) => {
        const queryParams = new URLSearchParams();
        // Map frontend query to backend DTO format
        if (query.page !== undefined) queryParams.append('Page', query.page);
        if (query.pageSize !== undefined) queryParams.append('PageSize', query.pageSize);
        if (query.search !== undefined) queryParams.append('Search', query.search);
        if (query.category !== undefined) queryParams.append('Category', query.category);
        if (query.level !== undefined) queryParams.append('Level', query.level);
        if (query.status !== undefined) queryParams.append('Status', query.status);
        if (query.instructorId !== undefined) queryParams.append('InstructorId', query.instructorId);
        if (query.sortBy !== undefined) queryParams.append('SortBy', query.sortBy);
        if (query.sortDirection !== undefined) queryParams.append('SortDirection', query.sortDirection);

        return apiRequest(`/api/admin/courses?${queryParams.toString()}`);
    },

    /**
     * Get course by ID
     */
    getCourseById: async (id) => {
        return apiRequest(`/api/admin/courses/public/id/${id}`);
    },

    /**
     * Create a new course
     */
    createCourse: async (courseData) => {
        // Convert to FormData for [FromForm] backend
        const formData = new FormData();
        Object.keys(courseData).forEach(key => {
            if (courseData[key] !== null && courseData[key] !== undefined) {
                formData.append(key, courseData[key]);
            }
        });

        return apiRequest('/api/admin/courses', {
            method: 'POST',
            body: formData, // FormData for [FromForm] backend
        });
    },

    /**
     * Update an existing course
     */
    updateCourse: async (id, courseData) => {
        // Convert to FormData for [FromForm] backend
        const formData = new FormData();
        Object.keys(courseData).forEach(key => {
            if (courseData[key] !== null && courseData[key] !== undefined) {
                formData.append(key, courseData[key]);
            }
        });

        return apiRequest(`/api/admin/courses/${id}`, {
            method: 'PUT',
            body: formData, // FormData for [FromForm] backend
        });
    },

    /**
     * Delete a course
     */
    deleteCourse: async (id) => {
        return apiRequest(`/api/admin/courses/${id}`, {
            method: 'DELETE',
        });
    },

    /**
     * Publish a course
     */
    publishCourse: async (id) => {
        return apiRequest(`/api/admin/courses/${id}/publish`, {
            method: 'POST',
        });
    },

    /**
     * Show or hide a course on the public Courses page
     */
    setPublicMenuVisibility: async (id, showInPublicMenu) => {
        return apiRequest(`/api/admin/courses/${id}/public-menu-visibility`, {
            method: 'PATCH',
            body: JSON.stringify({ showInPublicMenu }),
        });
    },

    /**
     * Get all active courses for public
     */
    getActiveCourses: async (page = 1, pageSize = 50) => {
        return apiRequest(`/api/admin/courses/public?page=${page}&pageSize=${pageSize}`);
    },

    /**
     * Get featured courses for public
     */
    getFeaturedCourses: async () => {
        return apiRequest('/api/admin/courses/public/featured');
    },

    /**
     * Get courses by section for public
     */
    getCoursesBySection: async (section) => {
        return apiRequest(`/api/admin/courses/public/section/${encodeURIComponent(section)}`);
    },

    /**
     * Get course by slug for public
     */
    getCourseBySlug: async (slug) => {
        return apiRequest(`/api/admin/courses/public/${slug}`);
    },

    /**
     * Check course availability
     */
    checkCourseAvailability: async (courseId) => {
        return apiRequest(`/api/admin/courses/${courseId}/check-availability`);
    },

    /**
     * Get CourseLevel constants
     */
    getCourseLevels: async () => {
        return apiRequest('/api/admin/courses/constants/levels');
    },

    /**
     * Get CourseStatus constants
     */
    getCourseStatuses: async () => {
        return apiRequest('/api/admin/courses/constants/statuses');
    },

    /**
     * Get DurationUnits constants
     */
    getDurationUnits: async () => {
        return apiRequest('/api/admin/courses/constants/duration-units');
    },

    /**
     * Get all active coupons
     */
    getCoupons: async () => {
        return apiRequest('/api/admin/courses/coupons');
    }
};

// LESSON API METHODS
const lessonAPI = {
    /**
     * Get all lessons with filtering and pagination
     */
    getAllLessons: async (params = {}) => {
        const queryParams = new URLSearchParams();
        if (params.courseId) queryParams.append('courseId', params.courseId);
        if (params.search) queryParams.append('search', params.search);
        if (params.page) queryParams.append('page', params.page);
        if (params.pageSize) queryParams.append('pageSize', params.pageSize);

        const queryString = queryParams.toString();
        return apiRequest(`/api/admin/lessons${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Get lesson by ID
     */
    getLessonById: async (id) => {
        return apiRequest(`/api/admin/lessons/${id}`);
    },

    /**
     * Get lessons by course ID
     */
    getLessonsByCourseId: async (courseId) => {
        return apiRequest(`/api/admin/lessons/course/${courseId}`);
    },

    /**
     * Create a new lesson
     */
    createLesson: async (lessonData) => {
        // Convert to FormData for [FromForm] backend
        const formData = new FormData();
        Object.keys(lessonData).forEach(key => {
            if (lessonData[key] !== null && lessonData[key] !== undefined) {
                formData.append(key, lessonData[key]);
            }
        });

        return apiRequest('/api/admin/lessons', {
            method: 'POST',
            body: formData,
        });
    },

    /**
     * Update an existing lesson
     */
    updateLesson: async (id, lessonData) => {
        return apiRequest(`/api/admin/lessons/${id}`, {
            method: 'PUT',
            body: JSON.stringify(lessonData),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },

    /**
     * Delete a lesson
     */
    deleteLesson: async (id) => {
        return apiRequest(`/api/admin/lessons/${id}`, {
            method: 'DELETE',
        });
    },

    /**
     * Reorder lessons
     */
    reorderLessons: async (lessonOrders) => {
        return apiRequest('/api/admin/lessons/reorder', {
            method: 'PUT',
            body: JSON.stringify(lessonOrders),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },

    /**
     * Add lesson attachment
     */
    addLessonAttachment: async (lessonId, formData) => {
        return apiRequest(`/api/admin/lessons/${lessonId}/attachments`, {
            method: 'POST',
            body: formData,
        });
    },

    /**
     * Remove lesson attachment
     */
    removeLessonAttachment: async (attachmentId) => {
        return apiRequest(`/api/admin/lessons/attachments/${attachmentId}`, {
            method: 'DELETE',
        });
    }
};

// ENROLLMENT API METHODS
const enrollmentAPI = {
    /**
     * Register for course
     */
    registerForCourse: async (courseId, request) => {
        return apiRequest(`/api/forms/course/${courseId}`, {
            method: 'POST',
            body: JSON.stringify(request),
        });
    },

    /**
     * Check enrollment status
     */
    checkEnrollment: async (courseId) => {
        return apiRequest(`/api/forms/course/${courseId}/check-enrollment`);
    },

    /**
     * Create enrollment
     */
    createEnrollment: async (request) => {
        return apiRequest('/api/enrollment', {
            method: 'POST',
            body: JSON.stringify(request),
        });
    },

    /**
     * Verify payment
     */
    verifyPayment: async (enrollmentId) => {
        return apiRequest(`/api/enrollment/${enrollmentId}/verify-payment`, {
            method: 'POST',
        });
    },

    /**
     * Get user enrollments
     */
    getUserEnrollments: async () => {
        return apiRequest('/api/enrollment/user');
    },

    /**
     * Check enrollment status by course
     */
    checkEnrollmentStatus: async (courseId) => {
        return apiRequest(`/api/enrollment/check/${courseId}`);
    }
};
// COURSE REVIEW API METHODS
const courseReviewAPI = {
    /**
     * Get review by ID
     */
    getReviewById: async (id) => {
        return apiRequest(`/api/coursereview/${id}`);
    },

    /**
     * Get reviews by course ID (public - no auth required)
     */
    getReviewsByCourseId: async (courseId) => {
        return apiRequest(`/api/coursereview/course/${courseId}`);
    },

    /**
     * Get reviews by student ID
     */
    getReviewsByStudentId: async (studentId) => {
        return apiRequest(`/api/coursereview/student/${studentId}`);
    },

    /**
     * Create a new review
     */
    createReview: async (request) => {
        return apiRequest('/api/coursereview', {
            method: 'POST',
            body: JSON.stringify(request),
        });
    },

    /**
     * Update an existing review
     */
    updateReview: async (id, request) => {
        return apiRequest(`/api/coursereview/${id}`, {
            method: 'PUT',
            body: JSON.stringify(request),
        });
    },

    /**
     * Delete a review
     */
    deleteReview: async (id) => {
        return apiRequest(`/api/coursereview/${id}`, {
            method: 'DELETE',
        });
    },

    /**
     * Check if student has reviewed a course
     */
    checkReviewStatus: async (courseId) => {
        return apiRequest(`/api/coursereview/course/${courseId}/check`);
    },

    // ADMIN METHODS
    /**
     * Get all reviews with filtering (Admin only)
     */
    getAllReviews: async (params = {}) => {
        const queryParams = new URLSearchParams();
        if (params.approved !== undefined) queryParams.append('approved', params.approved);
        if (params.courseId) queryParams.append('courseId', params.courseId);
        if (params.studentId) queryParams.append('studentId', params.studentId);
        if (params.page) queryParams.append('page', params.page);
        if (params.pageSize) queryParams.append('pageSize', params.pageSize);

        return apiRequest(`/api/coursereview/admin/all?${queryParams.toString()}`);
    },

    /**
     * Get pending reviews (Admin only)
     */
    getPendingReviews: async () => {
        return apiRequest('/api/coursereview/admin/pending');
    },

    /**
     * Get reviews by status (Admin only)
     */
    getReviewsByStatus: async (status) => {
        return apiRequest(`/api/coursereview/admin/status/${status}`);
    },

    /**
     * Approve a review (Admin only)
     */
    approveReview: async (id) => {
        return apiRequest(`/api/coursereview/admin/${id}/approve`, {
            method: 'POST',
        });
    },

    /**
     * Reject a review (Admin only)
     */
    rejectReview: async (id) => {
        return apiRequest(`/api/coursereview/admin/${id}/reject`, {
            method: 'POST',
        });
    }
};

// CATEGORY API METHODS
const categoryAPI = {
    /**
     * Get all categories
     */
    getAllCategories: async () => {
        return apiRequest('/api/admin/categories');
    },

    /**
     * Get category by ID
     */
    getCategoryById: async (id) => {
        return apiRequest(`/api/admin/categories/${id}`);
    },

    /**
     * Create a new category
     */
    createCategory: async (categoryData) => {
        return apiRequest('/api/admin/categories', {
            method: 'POST',
            body: JSON.stringify(categoryData),
        });
    },

    /**
     * Update an existing category
     */
    updateCategory: async (id, categoryData) => {
        return apiRequest(`/api/admin/categories/${id}`, {
            method: 'PUT',
            body: JSON.stringify(categoryData),
        });
    },

    /**
     * Delete a category
     */
    deleteCategory: async (id) => {
        return apiRequest(`/api/admin/categories/${id}`, {
            method: 'DELETE',
        });
    },

    /**
     * Get all unique MasterName values
     */
    getUniqueMasterNames: async () => {
        return apiRequest('/api/admin/categories/master-names');
    },
    getMasterNamesConstants: async () => {
        return apiRequest('/api/admin/categories/master-names-constants');
    },

    /**
     * Get all master data with optional filtering
     */
    getAllMasters: async (masterName = null) => {
        const url = masterName
            ? `/api/admin/categories/masters?masterName=${encodeURIComponent(masterName)}`
            : '/api/admin/categories/masters';
        return apiRequest(url);
    },

    /**
     * Create a new master data entry
     */
    createMaster: async (masterData) => {
        return apiRequest('/api/admin/categories/masters', {
            method: 'POST',
            body: JSON.stringify(masterData),
        });
    },

    /**
     * Update an existing master data entry
     */
    updateMaster: async (id, masterData) => {
        return apiRequest(`/api/admin/categories/masters/${id}`, {
            method: 'PUT',
            body: JSON.stringify(masterData),
        });
    },

    /**
     * Delete a master data entry
     */
    deleteMaster: async (id) => {
        return apiRequest(`/api/admin/categories/masters/${id}`, {
            method: 'DELETE',
        });
    }
};

// SECTION API METHODS
const sectionAPI = {
    /**
     * Get all sections (admin only - includes inactive)
     */
    getAllSections: async () => {
        return apiRequest('/api/admin/sections');
    },

    /**
     * Get active sections only (public access)
     */
    getActiveSections: async () => {
        return apiRequest('/api/admin/sections/active');
    },

    /**
     * Get section by ID
     */
    getSectionById: async (id) => {
        return apiRequest(`/api/admin/sections/${id}`);
    },

    /**
     * Get section by slug
     */
    getSectionBySlug: async (slug) => {
        return apiRequest(`/api/admin/sections/slug/${slug}`);
    },

    /**
     * Create a new section
     */
    createSection: async (sectionData) => {
        return apiRequest('/api/admin/sections', {
            method: 'POST',
            body: JSON.stringify(sectionData),
        });
    },

    /**
     * Update an existing section
     */
    updateSection: async (id, sectionData) => {
        return apiRequest(`/api/admin/sections/${id}`, {
            method: 'PUT',
            body: JSON.stringify(sectionData),
        });
    },

    /**
     * Delete a section
     */
    deleteSection: async (id) => {
        return apiRequest(`/api/admin/sections/${id}`, {
            method: 'DELETE',
        });
    }
};

// Response handler utility
const handleApiResponse = async (apiCall, options = {}) => {
    const { showSuccessToast = false, showErrorToast = true } = options;

    try {
        const response = await apiCall;

        return response;
    } catch (error) {
        if (showErrorToast) {
            const Swal = (await import('sweetalert2')).default;
            await Swal.fire({
                icon: 'error',
                title: 'API Error',
                text: error.message || 'An error occurred while processing your request.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#10b981',
            });
        }
        throw error;
    }
};

// ==================================================
// BANK ACCOUNT DETAIL API METHODS
const bankAccountDetailAPI = {
    /**
     * Get all bank account details
     */
    getAll: async ({ page = 1, pageSize = 5 } = {}) => {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('pageSize', pageSize.toString());
        return apiRequest(`/api/bank-account-details?${params.toString()}`);
    },

    /**
     * Get active bank account details
     */
    getActive: async (country) => {
        const query = country ? `?country=${encodeURIComponent(country)}` : '';
        return apiRequest(`/api/bank-account-details/active${query}`);
    },

    /**
     * Get bank account detail by ID
     */
    getById: async (id) => {
        return apiRequest(`/api/bank-account-details/${id}`);
    },

    /**
     * Create bank account detail
     */
    create: async (request) => {
        return apiRequest('/api/bank-account-details', {
            method: 'POST',
            body: request,
        });
    },

    /**
     * Update bank account detail
     */
    update: async (id, request) => {
        return apiRequest(`/api/bank-account-details/${id}`, {
            method: 'PUT',
            body: request,
        });
    },

    /**
     * Delete bank account detail
     */
    remove: async (id) => {
        return apiRequest(`/api/bank-account-details/${id}`, {
            method: 'DELETE',
        });
    }
};

// INSTRUCTOR API METHODS
// INSTRUCTOR (TEACHER) API METHODS
const instructorAPI = {
    /**
     * Get all instructors (legacy endpoint for dropdowns)
     */
    getAllInstructors: async () => {
        return apiRequest('/api/instructor/all');
    },
    /**
     * Public faculty list with courses/subjects
     */
    getFaculty: async () => {
        return apiRequest('/api/instructor/faculty');
    },
    /**
     * Get all instructors with pagination and filtering (Admin)
     */
    getAll: async ({ page = 1, pageSize = 5, search = '', status = 'all' } = {}) => {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('pageSize', pageSize.toString());
        if (search) params.append('search', search);
        if (status !== 'all') params.append('status', status);
        return apiRequest(`/api/admin/instructors?${params.toString()}`);
    },
    /**
     * Get instructor by ID
     */
    getById: async (id) => {
        return apiRequest(`/api/admin/instructors/${id}`);
    },
    /**
     * Update instructor status (Active/Inactive)
     */
    updateStatus: async (id, isActive) => {
        return apiRequest(`/api/admin/instructors/${id}/status`, {
            method: 'PUT',
            body: JSON.stringify({ isActive })
        });
    },
    /**
     * Soft delete instructor (Set IsDeleted = true)
     */
    delete: async (id) => {
        return apiRequest(`/api/admin/instructors/${id}`, {
            method: 'DELETE'
        });
    }
};

// COUNSELING API METHODS
// ==================================================
const counselingAPI = {
    /**
     * Admin: Get all counseling records
     */
    getAll: async (includeDeleted = false) => {
        const query = includeDeleted ? '?includeDeleted=true' : '';
        return apiRequest(`/api/admin/counseling${query}`);
    },

    /**
     * Admin: Get counseling by id
     */
    getById: async (id) => {
        return apiRequest(`/api/admin/counseling/${id}`);
    },

    /**
     * Admin: Create counseling
     */
    create: async (payload) => {
        return apiRequest('/api/admin/counseling', {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    },

    /**
     * Admin: Update counseling
     */
    update: async (id, payload) => {
        return apiRequest(`/api/admin/counseling/${id}`, {
            method: 'PUT',
            body: JSON.stringify(payload),
        });
    },

    /**
     * Admin: Delete counseling (soft delete)
     */
    remove: async (id) => {
        return apiRequest(`/api/admin/counseling/${id}`, {
            method: 'DELETE',
        });
    },

    /**
     * Public: Get active counseling list
     */
    getPublic: async () => {
        return apiRequest('/api/counseling');
    },

    /**
     * Student: Latest counseling registration
     */
    getLatestRegistration: async () => {
        return apiRequest('/api/counseling-registrations/me/latest');
    },

    /**
     * Student: Get counseling registration by id
     */
    getRegistrationById: async (id) => {
        return apiRequest(`/api/counseling-registrations/${id}`);
    },

    /**
     * Student: Submit counseling registration
     */
    createRegistration: async (payload) => {
        return apiRequest('/api/counseling-registrations', {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    },

    /**
     * Student: Create counseling registration
     */
    createRegistration: async (payload) => {
        return apiRequest('/api/counseling-registrations', {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    },

    /**
     * Student: Get availability for a counseling service
     */
    getAvailability: async (counselingId) => {
        return apiRequest(`/api/counseling-registrations/${counselingId}/availability`);
    },
};

// Payment Gateway module removed

// HOMESCHOOLING API METHODS
// ==================================================
const homeschoolingAPI = {
    // Public endpoints
    getPricing: async (params = {}) => {
        const q = new URLSearchParams();
        if (params.programType) q.append('programType', params.programType);
        return apiRequest(`/api/homeschooling/pricing${q.toString() ? `?${q.toString()}` : ''}`);
    },
    getAllContent: async () => {
        return apiRequest('/api/homeschooling/content');
    },
    getContentByCategory: async ({ category }) => {
        const q = new URLSearchParams();
        if (category) q.append('category', category);
        return apiRequest(`/api/homeschooling/content/category?${q.toString()}`);
    },
    getSubjects: async (params = {}) => {
        const q = new URLSearchParams();
        if (params.isActive !== undefined) q.append('isActive', params.isActive);
        if (params.category) q.append('category', params.category);
        return apiRequest(`/api/homeschooling/subjects${q.toString() ? `?${q.toString()}` : ''}`);
    },
    calculatePartTimeFee: async (subjectIds = [], paymentPlan = 'Monthly') => {
        return apiRequest(`/api/homeschooling/subjects/calculate-fee?paymentPlan=${encodeURIComponent(paymentPlan)}`, {
            method: 'POST',
            body: JSON.stringify(subjectIds)
        });
    },

    // Registration
    createRegistration: async (request) => {
        // Follow FormsController pattern for public submission
        return apiRequest('/api/homeschooling/registrations', {
            method: 'POST',
            body: JSON.stringify(request)
        });
    },
    uploadMmpi: async (formData) => {
        return apiRequest('/api/homeschooling/registrations/upload-mmpi', {
            method: 'POST',
            body: formData
        });
    },
    getRegistrationById: async (id) => {
        return apiRequest(`/api/homeschooling/registrations/${id}`);
    },
    updateRegistration: async (request) => {
        return apiRequest('/api/homeschooling/registrations', {
            method: 'PUT',
            body: JSON.stringify(request)
        });
    },
    deleteRegistration: async (id) => {
        return apiRequest(`/api/homeschooling/registrations/${id}`, {
            method: 'DELETE'
        });
    },
    getAllRegistrationsAdmin: async ({ page = 1, pageSize = 10, status, programType, courseStatus } = {}) => {
        const q = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
        if (status) q.append('status', status);
        if (programType) q.append('programType', programType);
        if (courseStatus) q.append('courseStatus', courseStatus);
        return apiRequest(`/api/homeschooling/admin/registrations?${q.toString()}`);
    },
    getCourseStatuses: async () => {
        return apiRequest('/api/homeschooling/course-statuses');
    },

    // Pricing (Admin)
    getAllPricingAdmin: async (params = {}) => {
        const q = new URLSearchParams();
        if (params.isActive !== undefined) q.append('isActive', params.isActive);
        if (params.programType) q.append('programType', params.programType);
        return apiRequest(`/api/homeschooling/admin/pricing${q.toString() ? `?${q.toString()}` : ''}`);
    },
    createPricing: async (request) => {
        return apiRequest('/api/homeschooling/pricing', {
            method: 'POST',
            body: JSON.stringify(request)
        });
    },
    updatePricing: async (id, request) => {
        return apiRequest(`/api/homeschooling/pricing/${id}`, {
            method: 'PUT',
            body: JSON.stringify({ ...request, Id: id })
        });
    },
    deletePricing: async (id) => {
        return apiRequest(`/api/homeschooling/pricing/${id}`, {
            method: 'DELETE'
        });
    },

    // Content (Admin)
    getAllContentAdmin: async (params = {}) => {
        const q = new URLSearchParams();
        if (params.contentType) q.append('contentType', params.contentType);
        if (params.ageGroup) q.append('ageGroup', params.ageGroup);
        if (params.programType) q.append('programType', params.programType);
        return apiRequest(`/api/homeschooling/admin/content${q.toString() ? `?${q.toString()}` : ''}`);
    },
    createContent: async (request) => {
        return apiRequest('/api/homeschooling/content', {
            method: 'POST',
            body: JSON.stringify(request)
        });
    },
    updateContent: async (id, request) => {
        return apiRequest(`/api/homeschooling/content/${id}`, {
            method: 'PUT',
            body: JSON.stringify({ ...request, Id: id })
        });
    },
    deleteContent: async (id) => {
        return apiRequest(`/api/homeschooling/content/${id}`, {
            method: 'DELETE'
        });
    },

    // Subjects (Admin)
    getAllSubjectsAdmin: async (params = {}) => {
        const q = new URLSearchParams();
        if (params.isActive !== undefined) q.append('isActive', params.isActive);
        if (params.category) q.append('category', params.category);
        return apiRequest(`/api/homeschooling/admin/subjects${q.toString() ? `?${q.toString()}` : ''}`);
    },
    createSubject: async (request) => {
        return apiRequest('/api/homeschooling/subjects', {
            method: 'POST',
            body: JSON.stringify(request)
        });
    },
    updateSubject: async (id, request) => {
        return apiRequest(`/api/homeschooling/subjects/${id}`, {
            method: 'PUT',
            body: JSON.stringify({ ...request, Id: id })
        });
    },
    deleteSubject: async (id) => {
        return apiRequest(`/api/homeschooling/subjects/${id}`, {
            method: 'DELETE'
        });
    },

    // Payments removed (no gateway dependency)

    // Form Config removed

    // Coupons (Admin)
    getAllCouponsAdmin: async (params = {}) => {
        const q = new URLSearchParams();
        if (params.isActive !== undefined) q.append('isActive', params.isActive);
        return apiRequest(`/api/homeschooling/admin/coupons${q.toString() ? `?${q.toString()}` : ''}`);
    },
    getCouponByIdAdmin: async (id) => {
        return apiRequest(`/api/homeschooling/admin/coupons/${id}`);
    },
    createCoupon: async (request) => {
        return apiRequest('/api/homeschooling/admin/coupons', {
            method: 'POST',
            body: JSON.stringify(request)
        });
    },
    updateCoupon: async (id, request) => {
        return apiRequest(`/api/homeschooling/admin/coupons/${id}`, {
            method: 'PUT',
            body: JSON.stringify({ ...request, Id: id })
        });
    },
    deleteCoupon: async (id) => {
        return apiRequest(`/api/homeschooling/admin/coupons/${id}`, {
            method: 'DELETE'
        });
    },
    validateCoupon: async (request, totalAmount = 0) => {
        return apiRequest(`/api/homeschooling/coupons/validate?totalAmount=${totalAmount}`, {
            method: 'POST',
            body: JSON.stringify(request)
        });
    },

    // Dashboard (Admin)
    getDashboardSummary: async () => {
        return apiRequest('/api/homeschooling/admin/dashboard');
    },

    // Student
    getStudentOverview: async () => {
        return apiRequest('/api/homeschooling/student/overview');
    },
    getStudentSubjects: async () => {
        return apiRequest('/api/homeschooling/student/subjects');
    },
    getStudentAttendance: async ({ date, page = 1, pageSize = 10 } = {}) => {
        const params = new URLSearchParams();
        if (date) params.append('date', date);
        params.append('page', page.toString());
        params.append('pageSize', pageSize.toString());
        const queryString = params.toString();
        return apiRequest(`/api/homeschooling/student/attendance/homeschooling${queryString ? `?${queryString}` : ''}`);
    },
    getStudentClassForSubject: async (subjectId) => {
        return apiRequest(`/api/homeschooling/student/subjects/${subjectId}/my-class`);
    },
    getStudentSubjectClasses: async (subjectId) => {
        return apiRequest(`/api/homeschooling/student/subjects/${subjectId}/classes`);
    },

    // Instructor
    getInstructorSubjects: async () => {
        return apiRequest('/api/homeschooling/instructor/subjects');
    },
    getInstructorStudents: async () => {
        return apiRequest('/api/homeschooling/instructor/students');
    },
    getInstructorStudentCount: async () => {
        return apiRequest('/api/homeschooling/instructor/student-count');
    },
    getInstructorAttendanceRoster: async ({ subjectId, date, lectureId, classId } = {}) => {
        const params = new URLSearchParams();
        if (date) params.append('date', date);
        if (lectureId) params.append('lectureId', lectureId);
        if (classId) params.append('classId', classId);
        const query = params.toString();
        return apiRequest(`/api/homeschooling/instructor/subjects/${subjectId}/attendance${query ? `?${query}` : ''}`);
    },
    submitInstructorAttendance: async (payload) => {
        return apiRequest('/api/homeschooling/instructor/attendance', {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    },

    // Lecture Management
    createLecture: async (lectureData) => {
        return apiRequest('/api/homeschooling/lectures', {
            method: 'POST',
            body: JSON.stringify(lectureData)
        });
    },
    getLecture: async (lectureId) => {
        return apiRequest(`/api/homeschooling/lectures/${lectureId}`);
    },
    getLecturesBySubject: async (subjectId, classId = null) => {
        const query = classId ? `?classId=${classId}` : '';
        return apiRequest(`/api/homeschooling/subjects/${subjectId}/lectures${query}`);
    },
    getLecturesByClass: async (classId) => {
        return apiRequest(`/api/homeschooling/instructor/classes/${classId}/lectures`);
    },
    getInstructorLectures: async (status = null) => {
        const query = status !== null ? `?status=${status}` : '';
        return apiRequest(`/api/homeschooling/instructor/lectures${query}`);
    },
    updateLecture: async (lectureData) => {
        return apiRequest('/api/homeschooling/lectures', {
            method: 'PUT',
            body: JSON.stringify(lectureData)
        });
    },
    updateLectureVideo: async (videoData) => {
        return apiRequest('/api/homeschooling/lectures/video', {
            method: 'PUT',
            body: JSON.stringify(videoData)
        });
    },
    uploadLectureVideo: async (lectureId, file, onProgress) => {
        const formData = new FormData();
        formData.append('file', file);

        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            const url = `${API_BASE_URL}/api/homeschooling/lectures/${lectureId}/upload-video`;

            xhr.open('POST', url, true);
            xhr.withCredentials = true;

            const accessToken = cookieUtils.getAccessToken();
            if (accessToken) {
                xhr.setRequestHeader('Authorization', `Bearer ${accessToken}`);
            }

            xhr.onreadystatechange = () => {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    try {
                        const contentType = xhr.getResponseHeader('content-type');
                        const responseData = contentType?.includes('application/json')
                            ? JSON.parse(xhr.responseText || '{}')
                            : xhr.responseText;

                        if (xhr.status >= 200 && xhr.status < 300) {
                            resolve(responseData);
                        } else {
                            reject(new ApiError(
                                responseData?.message || `HTTP ${xhr.status}`,
                                xhr.status,
                                responseData?.errors
                            ));
                        }
                    } catch (error) {
                        reject(new ApiError(error.message || 'Upload failed', xhr.status));
                    }
                }
            };

            xhr.onerror = () => reject(new ApiError('Network error while uploading video', 0));

            if (xhr.upload && typeof onProgress === 'function') {
                xhr.upload.onprogress = (event) => {
                    if (event.lengthComputable) {
                        const percent = Math.round((event.loaded / event.total) * 100);
                        onProgress(percent);
                    }
                };
            }

            xhr.send(formData);
        });
    },
    deleteLecture: async (lectureId) => {
        return apiRequest(`/api/homeschooling/lectures/${lectureId}`, {
            method: 'DELETE'
        });
    },
    updateLectureFeedbackGating: async (lectureId, isFeedbackGatingEnabled) => {
        return apiRequest(`/api/homeschooling/lectures/${lectureId}/feedback-gating`, {
            method: 'PUT',
            body: JSON.stringify({ isFeedbackGatingEnabled })
        });
    },
    startLecture: async (lectureId) => {
        return apiRequest(`/api/homeschooling/lectures/${lectureId}/start`, {
            method: 'POST'
        });
    },
    completeLecture: async (lectureId) => {
        return apiRequest(`/api/homeschooling/lectures/${lectureId}/complete`, {
            method: 'POST'
        });
    },
    getInstructorDashboardStats: async () => {
        return apiRequest('/api/homeschooling/instructor/dashboard-stats');
    },

    // Admin attendance
    getAdminAttendance: async ({ subjectId, instructorId, studentId, date, page = 1, pageSize = 10 } = {}) => {
        const params = new URLSearchParams();
        if (subjectId) params.append('subjectId', subjectId);
        if (instructorId) params.append('instructorId', instructorId);
        if (studentId) params.append('studentId', studentId);
        if (date) params.append('date', date);
        params.append('page', page.toString());
        params.append('pageSize', pageSize.toString());
        const query = params.toString();
        return apiRequest(`/api/homeschooling/admin/attendance${query ? `?${query}` : ''}`);
    },

    // Subject Classes
    getSubjectClasses: async (subjectId) => {
        return apiRequest(`/api/homeschooling/instructor/subjects/${subjectId}/classes`);
    },
    createSubjectClass: async (subjectId, data) => {
        return apiRequest(`/api/homeschooling/instructor/subjects/${subjectId}/classes`, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json' } });
    },
    updateSubjectClass: async (classId, data) => {
        return apiRequest(`/api/homeschooling/instructor/classes/${classId}`, { method: 'PUT', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json' } });
    },
    deleteSubjectClass: async (classId) => {
        return apiRequest(`/api/homeschooling/instructor/classes/${classId}`, { method: 'DELETE' });
    },
    assignStudentsToClass: async (classId, registrationIds) => {
        return apiRequest(`/api/homeschooling/instructor/classes/${classId}/students`, { method: 'POST', body: JSON.stringify({ registrationIds }), headers: { 'Content-Type': 'application/json' } });
    },
    removeStudentFromClass: async (classId, registrationId) => {
        return apiRequest(`/api/homeschooling/instructor/classes/${classId}/students/${registrationId}`, { method: 'DELETE' });
    },
    getStudentsGroupedByClass: async (subjectId) => {
        return apiRequest(`/api/homeschooling/instructor/subjects/${subjectId}/students-grouped`);
    }
};

const courseLecturesAPI = {
    getLecturesByCourse: async (courseId) => {
        return apiRequest(`/api/instructor/course-lectures/courses/${courseId}`);
    },
    getStudentLecturesByCourse: async (courseId) => {
        return apiRequest(`/api/student/courses/${courseId}/lectures`);
    },
    createLecture: async (lectureData) => {
        return apiRequest('/api/instructor/course-lectures', {
            method: 'POST',
            body: JSON.stringify(lectureData)
        });
    },
    updateLecture: async (lectureId, lectureData) => {
        return apiRequest(`/api/instructor/course-lectures/${lectureId}`, {
            method: 'PUT',
            body: JSON.stringify(lectureData)
        });
    },
    startLecture: async (lectureId) => {
        return apiRequest(`/api/instructor/course-lectures/${lectureId}/start`, {
            method: 'POST'
        });
    },
    completeLecture: async (lectureId) => {
        return apiRequest(`/api/instructor/course-lectures/${lectureId}/complete`, {
            method: 'POST'
        });
    },
    uploadLectureVideo: async (lectureId, file, onProgress) => {
        const formData = new FormData();
        formData.append('file', file);

        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            const url = `${API_BASE_URL}/api/instructor/course-lectures/${lectureId}/upload-video`;

            xhr.open('POST', url, true);
            xhr.withCredentials = true;

            const accessToken = cookieUtils.getAccessToken();
            if (accessToken) {
                xhr.setRequestHeader('Authorization', `Bearer ${accessToken}`);
            }

            xhr.onreadystatechange = () => {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    try {
                        const contentType = xhr.getResponseHeader('content-type');
                        const responseData = contentType?.includes('application/json')
                            ? JSON.parse(xhr.responseText || '{}')
                            : xhr.responseText;

                        if (xhr.status >= 200 && xhr.status < 300) {
                            resolve(responseData);
                        } else {
                            reject(new ApiError(
                                responseData?.message || `HTTP ${xhr.status}`,
                                xhr.status,
                                responseData?.errors
                            ));
                        }
                    } catch (error) {
                        reject(new ApiError(error.message || 'Upload failed', xhr.status));
                    }
                }
            };

            xhr.onerror = () => reject(new ApiError('Network error while uploading video', 0));

            if (xhr.upload && typeof onProgress === 'function') {
                xhr.upload.onprogress = (event) => {
                    if (event.lengthComputable) {
                        const percent = Math.round((event.loaded / event.total) * 100);
                        onProgress(percent);
                    }
                };
            }

            xhr.send(formData);
        });
    },
    deleteLecture: async (lectureId) => {
        return apiRequest(`/api/instructor/course-lectures/${lectureId}`, {
            method: 'DELETE'
        });
    },
    updateFeedbackGating: async (lectureId, isFeedbackGatingEnabled) => {
        return apiRequest(`/api/instructor/course-lectures/${lectureId}/feedback-gating`, {
            method: 'PUT',
            body: JSON.stringify({ isFeedbackGatingEnabled })
        });
    }
};

const courseRegistrationAPI = {
    createRegistration: async (payload) => {
        return apiRequest('/api/course-registrations', {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    },
    getLatestForStudent: async () => {
        return apiRequest('/api/course-registrations/me/latest');
    },
    getPendingAccessRegistrations: async () => {
        return apiRequest('/api/course-registrations/me/pending-access');
    },
    validateCoupon: async (payload) => {
        return apiRequest('/api/course-registrations/validate-coupon', {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    },
    getMyRegistration: async (courseId) => {
        return apiRequest(`/api/course-registrations/course/${courseId}`);
    },
    getAllAdmin: async ({ page = 1, pageSize = 10, status, courseStatus, paymentStatus, search } = {}) => {
        const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
        if (status) params.append('status', status);
        if (courseStatus) params.append('courseStatus', courseStatus);
        if (paymentStatus) params.append('paymentStatus', paymentStatus);
        if (search) params.append('search', search);
        return apiRequest(`/api/admin/course-registrations?${params.toString()}`);
    },
    updateRegistration: async (payload) => {
        return apiRequest('/api/admin/course-registrations', {
            method: 'PUT',
            body: JSON.stringify(payload)
        });
    },
    deleteRegistration: async (id) => {
        return apiRequest(`/api/admin/course-registrations/${id}`, {
            method: 'DELETE'
        });
    },
    getRegistrationStatuses: async () => {
        return apiRequest('/api/admin/course-registrations/registration-statuses');
    },
    getCourseStatuses: async () => {
        return apiRequest('/api/admin/course-registrations/course-statuses');
    },
    getPaymentStatuses: async () => {
        return apiRequest('/api/admin/course-registrations/payment-statuses');
    }
};

const counselingRegistrationAPI = {
    getAllAdmin: async ({ page = 1, pageSize = 10, bookingStatus, paymentStatus, search } = {}) => {
        const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
        if (bookingStatus) params.append('bookingStatus', bookingStatus);
        if (paymentStatus) params.append('paymentStatus', paymentStatus);
        if (search) params.append('search', search);
        return apiRequest(`/api/admin/counseling/registrations?${params.toString()}`);
    },
    getBookingStatuses: async () => apiRequest('/api/admin/counseling/registrations/booking-statuses'),
    getPaymentStatuses: async () => apiRequest('/api/admin/counseling/registrations/payment-statuses'),
    getByCounseling: async (counselingId) => apiRequest(`/api/counseling-registrations/counseling/${counselingId}`),
    getByIdAdmin: async (id) => apiRequest(`/api/admin/counseling/registrations/${id}`),
    updateStatusAdmin: async (id, payload) => apiRequest(`/api/admin/counseling/registrations/${id}/status`, {
        method: 'PUT',
        body: JSON.stringify(payload)
    }),
    updateSlotAdmin: async (id, payload) => apiRequest(`/api/admin/counseling/registrations/${id}/slot`, {
        method: 'PUT',
        body: JSON.stringify(payload)
    }),
    deleteAdmin: async (id) => apiRequest(`/api/admin/counseling/registrations/${id}`, {
        method: 'DELETE'
    }),
    getAvailabilityAdmin: async (counselingId) => apiRequest(`/api/admin/counseling/registrations/availability/${counselingId}`)
};

const paymentTransactionsAPI = {
    create: async (formData) => {
        return apiRequest('/api/payment-transactions', {
            method: 'POST',
            body: formData,
            isFormData: true
        });
    },
    generateReceipt: async (id) => {
        const res = await apiRequest(`/api/payment-transactions/${id}/generate-receipt`, {
            method: 'POST'
        });
        // Non-JSON response path: res is a Response
        const blob = await res.blob();
        const fileName = (res.headers.get('content-disposition') || '').split('filename=').pop() || `receipt-${id}.pdf`;
        return { blob, fileName: fileName.replace(/(^"|"$)/g, '') };
    },
    getAll: async ({ page = 1, pageSize = 20, status, paymentType, registrationId, from, to, search, gateway } = {}) => {
        const q = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
        if (status) q.append('status', status);
        if (paymentType) q.append('paymentType', paymentType);
        if (registrationId) q.append('registrationId', registrationId);
        if (from) q.append('from', from);
        if (to) q.append('to', to);
        if (search) q.append('search', search);
        if (gateway) q.append('gateway', gateway);
        return apiRequest(`/api/payment-transactions${q.toString() ? `?${q.toString()}` : ''}`);
    },
    getById: async (id) => apiRequest(`/api/payment-transactions/${id}`),
    update: async (id, payload) => {
        return apiRequest(`/api/payment-transactions/${id}`, {
            method: 'PUT',
            body: JSON.stringify(payload),
            timeout: 120000
        });
    },
    getStatuses: async () => apiRequest('/api/payment-transactions/statuses'),
    remove: async (id) => {
        return apiRequest(`/api/payment-transactions/${id}`, {
            method: 'DELETE'
        });
    }
};

// HDFC SMARTGATEWAY (ONLINE PAYMENT) API METHODS
// ==================================================
const hdfcPaymentAPI = {
    /**
     * Create an online payment session and get the hosted payment page URL.
     * @param {{ registrationId: string, paymentType: string }} data
     */
    createSession: async (data) => {
        return apiRequest('/api/hdfc/create-session', {
            method: 'POST',
            body: JSON.stringify(data)
        });
    },
    /**
     * Verify the final status of an order after the user returns from the gateway.
     */
    verifyOrder: async (orderId) => apiRequest(`/api/hdfc/verify/${encodeURIComponent(orderId)}`),
    /**
     * Reconcile the latest online payment attempt for a registration. Used by the retry / check-status
     * flow so an already-successful payment is detected before the user pays again.
     */
    resolveRegistration: async (registrationId) => apiRequest(`/api/hdfc/resolve/${encodeURIComponent(registrationId)}`),
    /**
     * Absolute URL for the downloadable PDF receipt of a successful order.
     */
    receiptUrl: (orderId) => `${API_BASE_URL}/api/hdfc/receipt/${encodeURIComponent(orderId)}`
};

// STUDENT API METHODS
// ==================================================
const studentAPI = {
    /**
     * Get all students with pagination and filtering
     */
    getAll: async ({ page = 1, pageSize = 5, search, status } = {}) => {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('pageSize', pageSize.toString());
        if (search) params.append('search', search);
        if (status && status !== 'all') params.append('status', status);
        return apiRequest(`/api/admin/students?${params.toString()}`);
    },
    /**
     * Get student by ID
     */
    getById: async (id) => {
        return apiRequest(`/api/admin/students/${id}`);
    },
    /**
     * Update student status (Active/Inactive)
     */
    updateStatus: async (id, isActive) => {
        return apiRequest(`/api/admin/students/${id}/status`, {
            method: 'PUT',
            body: JSON.stringify({ isActive })
        });
    },
    /**
     * Soft delete student (Set IsDeleted = true)
     */
    delete: async (id) => {
        return apiRequest(`/api/admin/students/${id}`, {
            method: 'DELETE'
        });
    }
};

// NOTIFICATION API METHODS
// ==================================================
const notificationAPI = {
    /**
     * Instructor: Send notification to students
     */
    send: async (data) => {
        // Use camelCase for JSON (ASP.NET Core will map to PascalCase DTO properties)
        const formattedData = {
            title: data.title || data.Title || '',
            message: data.message || data.Message || '',
            type: data.type || data.Type || 'in-app',
            priority: data.priority || data.Priority || 'normal',
            studentIds: data.studentIds || data.StudentIds || []
        };

        // Only include courseId if it's a valid GUID (not null, not 'all', not empty)
        const courseId = data.courseId !== undefined ? data.courseId : (data.CourseId !== undefined ? data.CourseId : null);
        if (courseId && courseId !== 'all' && courseId !== null && courseId !== undefined && courseId !== '') {
            const courseIdStr = String(courseId);
            // Validate GUID format before including
            const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
            if (guidRegex.test(courseIdStr)) {
                formattedData.courseId = courseIdStr;
            }
        }

        // Only include scheduledAt if provided
        const scheduledAt = data.scheduledAt !== undefined ? data.scheduledAt : (data.ScheduledAt !== undefined ? data.ScheduledAt : null);
        if (scheduledAt !== null && scheduledAt !== undefined) {
            formattedData.scheduledAt = scheduledAt;
        }

        return apiRequest('/api/instructor/notifications', {
            method: 'POST',
            body: JSON.stringify(formattedData),
            timeout: 60000 // 60 seconds timeout for notification sending
        });
    },
    /**
     * Instructor: Get all sent notifications
     */
    getInstructorNotifications: async ({ page = 1, pageSize = 10 } = {}) => {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('pageSize', pageSize.toString());
        return apiRequest(`/api/instructor/notifications?${params.toString()}`);
    },
    /**
     * Student: Get all notifications
     */
    getStudentNotifications: async () => {
        return apiRequest('/api/student/notifications');
    },
    /**
     * Student: Mark notification as read
     */
    markAsRead: async (notificationId) => {
        return apiRequest(`/api/student/notifications/${notificationId}/read`, {
            method: 'PUT'
        });
    },
    /**
     * Admin: Get all notifications with filters
     */
    getAdminNotifications: async ({ page = 1, pageSize = 10, search, status = 'all' } = {}) => {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('pageSize', pageSize.toString());
        if (search) params.append('search', search);
        if (status !== 'all') params.append('status', status);
        return apiRequest(`/api/admin/notifications?${params.toString()}`);
    },
    /**
     * Admin: Get notification statistics
     */
    getAdminStats: async () => {
        return apiRequest('/api/admin/notifications/stats');
    }
};

const articleAPI = {
    getPublished: async (page = 1, pageSize = 12, tag = null) => {
        const q = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
        if (tag) q.append('tag', tag);
        return apiRequest(`/api/articles/public?${q}`);
    },
    getBySlug: async (slug) => {
        return apiRequest(`/api/articles/public/${slug}`);
    },
    getMyArticles: async () => {
        return apiRequest('/api/articles/my');
    },
    create: async (formData) => {
        return apiRequest('/api/articles', { method: 'POST', body: formData, isFormData: true });
    },
    update: async (id, formData) => {
        return apiRequest(`/api/articles/${id}`, { method: 'PUT', body: formData, isFormData: true });
    },
    deleteArticle: async (id) => {
        return apiRequest(`/api/articles/${id}`, { method: 'DELETE' });
    },
    adminGetAll: async (status = null, page = 1, pageSize = 20) => {
        const q = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
        if (status) q.append('status', status);
        return apiRequest(`/api/articles/admin/all?${q}`);
    },
    adminGetById: async (id) => {
        return apiRequest(`/api/articles/admin/${id}`);
    },
    adminPublish: async (id) => {
        return apiRequest(`/api/articles/admin/${id}/publish`, { method: 'POST' });
    },
    adminReject: async (id, reason) => {
        return apiRequest(`/api/articles/admin/${id}/reject`, { method: 'POST', body: JSON.stringify({ reason }) });
    },
    adminDelete: async (id) => {
        return apiRequest(`/api/articles/admin/${id}`, { method: 'DELETE' });
    },
    adminDownloadPdf: async (id) => {
        const res = await apiRequest(`/api/articles/admin/${id}/pdf`);
        const blob = await res.blob();
        const fileName = (res.headers.get('content-disposition') || '').split('filename=').pop() || `article-${id}.pdf`;
        return { blob, fileName: fileName.replace(/(^"|"$)/g, '') };
    }
};

const lectureFeedbackAPI = {
    submit: async (data) => {
        return apiRequest('/api/lecture-feedback', { method: 'POST', body: JSON.stringify(data) });
    },
    getMyFeedbacks: async (contextId, lectureType = 'course') => {
        const qs = lectureType && lectureType !== 'course' ? `?lectureType=${encodeURIComponent(lectureType)}` : '';
        return apiRequest(`/api/lecture-feedback/my/${contextId}${qs}`);
    },
    adminGetAll: async (courseId = null) => {
        const params = courseId ? `?courseId=${courseId}` : '';
        return apiRequest(`/api/lecture-feedback/admin${params}`);
    },
    adminGetByCourse: async (courseId) => {
        return apiRequest(`/api/lecture-feedback/admin/${courseId}`);
    }
};

const adminFeedbackGatingAPI = {
    audit: async () => {
        return apiRequest('/api/admin/feedback-gating/audit');
    },
    reset: async (body) => {
        return apiRequest('/api/admin/feedback-gating/reset', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    }
};

const monthlyPaymentsAPI = {
    getDue: async () => apiRequest('/api/student/monthly-payments/due'),
    submit: async (formData) => apiRequest('/api/student/monthly-payments', {
        method: 'POST',
        body: formData,
        isFormData: true
    }),
    getFilterOptions: async () => apiRequest('/api/admin/monthly-payments/filter-options'),
    list: async (params = {}) => {
        const qs = new URLSearchParams();
        Object.entries(params).forEach(([k, v]) => {
            if (v !== undefined && v !== null && v !== '') qs.append(k, v);
        });
        const query = qs.toString();
        return apiRequest(`/api/admin/monthly-payments${query ? `?${query}` : ''}`);
    },
    review: async (id, body) => apiRequest(`/api/admin/monthly-payments/${id}/review`, {
        method: 'PUT',
        body: JSON.stringify(body)
    })
};

const lectureWatchAPI = {
    getProgress: async (lectureType, lectureId) => {
        return apiRequest(`/api/lecture-watch/${lectureType}/${lectureId}`);
    },
    saveProgress: async ({ lectureId, lectureType, lastPositionSeconds, durationSeconds }) => {
        return apiRequest('/api/lecture-watch', {
            method: 'POST',
            body: JSON.stringify({
                lectureId,
                lectureType,
                lastPositionSeconds,
                durationSeconds
            })
        });
    },
    saveProgressBeacon: ({ lectureId, lectureType, lastPositionSeconds, durationSeconds }) => {
        try {
            const url = `${API_BASE_URL}/api/lecture-watch`;
            const accessToken = cookieUtils.getAccessToken();
            const headers = { 'Content-Type': 'application/json' };
            if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;
            // fetch with keepalive lets the request finish even as the tab closes,
            // while still allowing us to attach the Bearer token (sendBeacon can't).
            fetch(url, {
                method: 'POST',
                headers,
                body: JSON.stringify({ lectureId, lectureType, lastPositionSeconds, durationSeconds }),
                keepalive: true,
                credentials: 'include'
            }).catch(() => {});
            return true;
        } catch {
            return false;
        }
    }
};

const preRegistrationAPI = {
    create: async (formData) => apiRequest('/api/pre-registrations', {
        method: 'POST',
        body: formData,
        isFormData: true,
        timeout: 2 * 60 * 1000
    }),
    paymentConfig: async () => apiRequest('/api/pre-registrations/payment-config'),
    adminGetAll: async (status = null, search = null) => {
        const q = new URLSearchParams();
        if (status) q.append('status', status);
        if (search) q.append('search', search);
        const suffix = q.toString() ? `?${q}` : '';
        return apiRequest(`/api/pre-registrations/admin${suffix}`);
    },
    adminUpdateStatus: async (id, status) => apiRequest(`/api/pre-registrations/admin/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status }) }),
    adminDelete: async (id) => apiRequest(`/api/pre-registrations/admin/${id}`, { method: 'DELETE' })
};

const homeschoolingPreRegistrationAPI = {
    create: async (payload) => apiRequest('/api/homeschooling/pre-registrations', {
        method: 'POST',
        body: JSON.stringify(payload)
    }),
    adminGetAll: async (status = null, search = null) => {
        const q = new URLSearchParams();
        if (status) q.append('status', status);
        if (search) q.append('search', search);
        const suffix = q.toString() ? `?${q}` : '';
        return apiRequest(`/api/homeschooling/pre-registrations/admin${suffix}`);
    },
    adminUpdateStatus: async (id, status) => apiRequest(`/api/homeschooling/pre-registrations/admin/${id}/status`, {
        method: 'PATCH',
        body: JSON.stringify({ status })
    }),
    adminDelete: async (id) => apiRequest(`/api/homeschooling/pre-registrations/admin/${id}`, { method: 'DELETE' })
};

const blogAPI = {
    getPublished: async (page = 1, pageSize = 24, type = null) => {
        const q = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
        if (type) q.append('type', type);
        return apiRequest(`/api/blogs/public?${q}`);
    },
    adminGetAll: async () => apiRequest('/api/blogs/admin'),
    adminCreate: async (formData) => apiRequest('/api/blogs/admin', { method: 'POST', body: formData, isFormData: true, timeout: 30 * 60 * 1000 }),
    adminUpdate: async (id, formData) => apiRequest(`/api/blogs/admin/${id}`, { method: 'PUT', body: formData, isFormData: true, timeout: 30 * 60 * 1000 }),
    adminDelete: async (id) => apiRequest(`/api/blogs/admin/${id}`, { method: 'DELETE' })
};

export { authAPI, courseAPI, lessonAPI, enrollmentAPI, courseReviewAPI, categoryAPI, sectionAPI, bankAccountDetailAPI, homeschoolingAPI, courseRegistrationAPI, counselingRegistrationAPI, instructorAPI, paymentTransactionsAPI, hdfcPaymentAPI, studentAPI, notificationAPI, courseLecturesAPI, counselingAPI, articleAPI, blogAPI, preRegistrationAPI, homeschoolingPreRegistrationAPI, lectureFeedbackAPI, lectureWatchAPI, adminFeedbackGatingAPI, monthlyPaymentsAPI, ApiError, handleApiResponse };


